import Component from '@glimmer/component';
import { t } from 'ember-intl';
import {
  REPORT_TYPE_MARKETPARITY,
  REPORT_TYPE_MARKETRATES,
  REPORT_TYPE_PARITY,
  REPORT_TYPE_PARITY_INSIGHT,
  REPORT_TYPE_RATES,
  REPORT_TYPE_REVENUE_INSIGHT,
  TYPE_MARKET_INSIGHT,
} from 'frontend-utils/utils/constants/constant-values';

interface SettingsReportsTablesCellsTdReportsTypeSignature {
  Args: {
    cellData: unknown;
  };
}

export default class SettingsReportsTablesCellsTdReportsType extends Component<SettingsReportsTablesCellsTdReportsTypeSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get reportType() {
    let type = '';

    switch (this.args.cellData) {
      case TYPE_MARKET_INSIGHT:
        type = 'reports.type.market_insight';
        break;
      case REPORT_TYPE_RATES:
        type = 'reports.type.hotel_rates';
        break;
      case REPORT_TYPE_PARITY:
        type = 'reports.type.hotel_parity';
        break;
      case REPORT_TYPE_MARKETRATES:
        type = 'reports.type.market_rates';
        break;
      case REPORT_TYPE_MARKETPARITY:
        type = 'reports.type.market_parity';
        break;
      case REPORT_TYPE_REVENUE_INSIGHT:
        type = 'reports.type.revenue_insight';
        break;
      case REPORT_TYPE_PARITY_INSIGHT:
        type = 'settings.reports.parity_report';
        break;
      default:
        type = '';
        break;
    }

    return type;
  }

  <template>
    {{#if this.reportType}}
      {{t this.reportType}}
    {{/if}}
  </template>
}
